import { resolveFormValidationError, setErrorsToForm } from "@/utils/formUtils";
import { validations } from "@/utils/validationUtils";
import { Col, Form, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useDownloadCommissionsBatchOutputsAsZip } from "../../../../../common/api/queries";
import LabelWithTooltip from "../../../../../common/components/form/labels/LabelWithTooltip";
import { ModalSizes, rowGutter } from "../../../../../common/constants";
import { AgentSelect } from "../../../../enumerations/components/form/AgentSelect";
import { CommissionsBatch, DownloadBatchOutputsAsZip } from "../../types";

interface Props {
  batch: CommissionsBatch;
  open: boolean;
  onFormCancel: () => void;
}

export const CommissionsBatchOutputsAsZipForm = ({ open, batch, onFormCancel }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<DownloadBatchOutputsAsZip>();

  const downloadCommissionsBatchOutputsAsZip = useDownloadCommissionsBatchOutputsAsZip();

  // TODO Add fix for gainer IDs from outputs and remove disabled on field
  const allGainersIds: string[] | undefined = undefined;

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then((values) =>
        downloadCommissionsBatchOutputsAsZip.mutate(
          { id: batch.id, object: { gainerIds: values.gainerIds } },
          {
            onSuccess: onFormCancel,
            onError: (error) =>
              setErrorsToForm(form, "commissions.batch.attrs.attachmentsZipDownload", error.violations),
          },
        ),
      )
      .catch(resolveFormValidationError);
  };

  return (
    <Modal
      width={ModalSizes.SMALL}
      open={open}
      title={t("commissions.batch.titles.downloadBatchAttachmentsAsZip")}
      okText={t("common.download")}
      cancelText={t("common.cancel")}
      confirmLoading={downloadCommissionsBatchOutputsAsZip.isPending}
      afterClose={() => form.resetFields()}
      onOk={handleFormSubmit}
      onCancel={onFormCancel}
      mask={{ closable: false }}
    >
      <Form form={form} layout="vertical" name="commissionsBatchOutputsAsZipForm">
        <Row gutter={rowGutter}>
          <Col span={24}>
            <Form.Item
              name="gainerIds"
              label={
                <LabelWithTooltip
                  label={t("commissions.batch.attrs.attachmentsZipDownload.gainerIds")}
                  tooltip={t("commissions.batch.helpers.gainerIdsHint")}
                />
              }
              rules={[validations.none]}
            >
              <AgentSelect
                optionsProps={{ allowedIds: allGainersIds, forceRender: true }}
                allowClear
                isMultiple
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
